module.exports = __webpack_public_path__ + "assets/img/31_363_big.8549bbb0.jpg";